import React, { forwardRef } from 'react';
import MarketingSection from 'src/components/MarketingSection';
import IntroductionWithMedia from '../IntroductionWithMedia';
import styles from './styles.module.scss';
import { useTranslation, Trans } from 'next-i18next';
import useRouter from 'src/shared/hooks/useRouter';
import RoutePaths from 'src/config/RoutePaths';
import { fireGA } from 'src/utils/gaUtils';

const FeaturesSection = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const router = useRouter();

    const listData = [
        {
            imgUrl: '/static/images/platformFeatures/img_signup@2x.jpg',
            title: t('get_started_quickly'),
            description: <Trans i18nKey="get_started_quickly_description" />,
            buttonText: t('sign_up_to_know_more_button'),
            onClick: () => {
                fireGA('marketingQ421', 'clickSignUp', 'Features 1');
                router.pushPath(RoutePaths.REGISTER);
            },
        },
        {
            imgUrl: '/static/images/platformFeatures/img_contract@2x.jpg',
            title: t('no_paperwork_burden'),
            description: <Trans i18nKey="no_paperwork_burden_description" />,
            buttonText: t('learn_more_button'),
            onClick: () => {
                fireGA('marketingQ421', 'clickLearnMore', 'Features');
                router.pushPath(RoutePaths.OFFERINGS);
            },
        },
        {
            imgUrl: '/static/images/platformFeatures/img_report@2x.jpg',
            title: t('bring_portfolio_together'),
            description: <Trans i18nKey="bring_portfolio_together_description" />,
            buttonText: t('register_for_an_account_button'),
            onClick: () => {
                fireGA('marketingQ421', 'clickSignUp', 'Features 2');
                router.pushPath(RoutePaths.REGISTER);
            },
        },
    ];

    return (
        <MarketingSection containerClassName={styles.featuresSection} className={styles.inner} ref={ref}>
            {listData.map((x, i) => (
                <IntroductionWithMedia key={i} type={i % 2 === 0 ? 'rightMedia' : 'leftMedia'} {...x} />
            ))}
        </MarketingSection>
    );
});

export default FeaturesSection;
